const PWA_MANIFEST = {
  $schema: 'https://json.schemastore.org/web-manifest-combined.json',
  short_name: window.CONFIG.branding.shortName,
  name: window.CONFIG.branding.longName,
  description: window.CONFIG.branding.strapLine,
  icons: [
    {
      src: window.location.origin + '/lseg.svg',
      sizes: '512x512 192x192 64x64 32x32 24x24 16x16',
      type: 'image/svg+xml',
    },
  ],
  start_url: window.location.origin,
  display: 'standalone',
  display_override: ['window-controls-overlay', 'minimal-ui'],
  theme_color: '#f8f8f8',
  background_color: '#ffffff',
};

export function getPwaManifestBlobUrl() {
  const stringManifest = JSON.stringify(PWA_MANIFEST);
  const blob = new Blob([stringManifest], { type: 'application/json' });
  const manifestURL = URL.createObjectURL(blob);
  window.addEventListener('unload', () => {
    URL.revokeObjectURL(manifestURL);
  });
  return manifestURL;
}
